export const Constants = {

  ID_CATEGORIA_CICLO_BASICO: 1,
  TAMANHO_LIMITE_TITULO_TOPICO: 34,
  HOME_VERSION_DEFAULT: 'v1.0',
  HEADER_VERSION_DEFAULT: 'v1.0'

}

export default Constants
